import { render, staticRenderFns } from "./materialDirection.vue?vue&type=template&id=7319024c&scoped=true&"
import script from "./materialDirection.vue?vue&type=script&lang=js&"
export * from "./materialDirection.vue?vue&type=script&lang=js&"
import style0 from "./materialDirection.vue?vue&type=style&index=0&id=7319024c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319024c",
  null
  
)

export default component.exports